import { render } from "./App.vue?vue&type=template&id=7c6a8551&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=7c6a8551&lang=scss"

import exportComponent from "/var/www/stagging_env_sydney/karachi_stagging/services/amsterdam/demo1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__